export default __webpack_public_path__ + "static/media/bxl-html5.d399be1c.svg";